export default (result) => {
    const name = result.nombres?.snippet ?? ''
    //const lastName1 = result.apellido_paterno?.snippet ?? ''
    //const lastName2 = result.apellido_materno?.snippet ?? ''
    //return `${name} ${lastName1} ${lastName2}`.toLowerCase()
    return `${name}`.toLowerCase()
};